import React, { useRef, useState, useEffect } from "react";
import '../App.css'; // Loads in the CSS styling file
import PageHeader from "../components/PageHeader.js";
import landingPage from "../components/data/landingPage.svg";


function HomePage({ }) {
    return (
        <div>
            <PageHeader />
            <img
                style={{ width: '100%' }}
                src={landingPage}
                alt="Landing Page"
            />
        </div>
    );
};

export default HomePage; 